module.exports = "/_next/static/images/mastercard-9a62480670f377f17d07aacee54d6c11.png";